import Vue from 'vue'

import Button from 'objects/button/button'
import Icon from 'objects/icon/icon'

Vue.component('tt-button', Button)
Vue.component('tt-icon', Icon)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/init/objects.ts